import { useState } from "react";
import { useListSedecAudit } from "@/lib/backoffice-hooks";
import { usePaginationState } from "@/lib/use-paginated-query";
import { useDebouncedValue } from "@/lib/use-debounced-value";
import { AuditTable } from "@/components/AuditTable";
import SedecShell from "@/components/layout/SedecShell";

export default function SedecAudit() {
  const { page, size, setPage, setSize, resetToFirstPage } = usePaginationState(20);
  const [q, setQ] = useState("");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");
  const debouncedQ = useDebouncedValue(q, 300);

  const onQ = (v: string) => { setQ(v); resetToFirstPage(); };
  const onFrom = (v: string) => { setFrom(v); resetToFirstPage(); };
  const onTo = (v: string) => { setTo(v); resetToFirstPage(); };

  const { data, isLoading } = useListSedecAudit({
    page,
    size,
    q: debouncedQ.trim() || undefined,
    from: from ? `${from}T00:00:00Z` : undefined,
    to: to ? `${to}T23:59:59Z` : undefined,
  });

  return (
    <SedecShell>
      <div className="space-y-5">
        <header>
          <div className="text-xs uppercase tracking-wider text-slate-500">Journal d'audit complet</div>
          <h1 className="text-2xl font-bold text-navy">{data?.total ?? 0} entrées</h1>
        </header>
        <AuditTable
          data={data}
          isLoading={isLoading}
          q={q}
          onQ={onQ}
          from={from}
          onFrom={onFrom}
          to={to}
          onTo={onTo}
          page={page}
          size={size}
          onPage={setPage}
          onSize={setSize}
        />
      </div>
    </SedecShell>
  );
}
